import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Clock, CheckCircle, AlertCircle, Brain } from '../../components/icons';

export function InstructionsViewTR() {
  const navigate = useNavigate();

  const instructions = [
    {
      icon: Clock,
      title: 'Aceleniz Olmasin',
      description: 'Degerlendirme yaklasik 20-30 dakika surer. Dikkatinizi dagitmadan odaklanabileceginiZ sakin bir ortam bulun.'
    },
    {
      icon: CheckCircle,
      title: 'Durüst Olun',
      description: 'Her soruyu nasil hissetmeniz gerektigine gore degil, gercekte nasil hissettiginize gore cevaplayin. Dogru veya yanlis cevap yoktur.'
    },
    {
      icon: AlertCircle,
      title: 'Ilk Tepkinize Guvenin',
      description: 'Ilk tepkiniz genellikle en dogru olandir. Cevaplaarinizi cok fazla dusunmeyin.'
    },
    {
      icon: Brain,
      title: 'Gercek Durumlaari Dusunun',
      description: 'Cevaplarken, hayali senaryolari degil, gercek hayat durumlarinda tipik olarak nasil davrandiginizi dusunun.'
    }
  ];

  return (
    <div className="min-h-screen freud-bg py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="freud-display-sm text-chocolate-900 mb-4">
            Degerlendirme Talimatlari
          </h1>
          <p className="freud-text-lg text-chocolate-500">
            Degerlendirmenize baslamadan once lutfen bu yonergeleri okuyun.
          </p>
        </motion.div>

        <div className="space-y-6 mb-12">
          {instructions.map((instruction, index) => (
            <motion.div
              key={instruction.title}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className="freud-card-elevated p-6"
            >
              <div className="flex items-start gap-4">
                <div className="p-3 bg-sage-100 rounded-xl">
                  <instruction.icon className="w-6 h-6 text-sage-600" />
                </div>
                <div>
                  <h3 className="freud-heading-base text-chocolate-900 mb-2">
                    {instruction.title}
                  </h3>
                  <p className="freud-text-base text-chocolate-600">
                    {instruction.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="bg-sand-100 border border-sand-300 rounded-2xl p-6 mb-8"
        >
          <h3 className="freud-label text-sand-900 mb-2">Degerlendirme Olcegi</h3>
          <p className="freud-text-base text-sand-800 mb-4">
            Her ifadeyi 1 ile 7 arasinda bir olcekte degerlendireceksiniz:
          </p>
          <div className="flex justify-between freud-text-sm text-sand-700">
            <span>1 = Kesinlikle Katilmiyorum</span>
            <span>4 = Notr</span>
            <span>7 = Kesinlikle Katiliyorum</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="text-center"
        >
          <button
            onClick={() => navigate('/tr/assessment')}
            className="freud-btn-primary inline-flex items-center gap-2"
          >
            Degerlendirmeye Basla
            <ArrowRight className="w-5 h-5" />
          </button>
        </motion.div>
      </div>
    </div>
  );
}
